import { call, put } from "typed-redux-saga";
import { SortOrderResponseBody } from "../../core/api/requests/sortOrder/search/types";
import { sortOrderSearchApi } from "../../core/http/httpClient";
import { ApiResponse } from "../../core/types";
import { takeEveryFsa } from "../operations";
import { sortOrderActions } from "./actions";
import { SortOrder } from "./types";

export function* sortOrderSaga() {
  yield takeEveryFsa(sortOrderActions.getSortOrder.started, function* (action) {
    const { onComplete, onError, onSuccess, ...body } = action.payload;
    const { response, error }: ApiResponse<SortOrderResponseBody> = yield call(
      () => {
        return sortOrderSearchApi
          .call(body)
          .then((response) => ({ response }))
          .catch((error) => ({ error }));
      },
    );

    onComplete?.();

    if (!response || error) return onError?.(error);

    const result = response.data.sort_orders.map<SortOrder>((item) => ({
      type: item.type,
      sortOrder: item.sort_order,
    }));

    yield* put(
      sortOrderActions.getSortOrder.done({
        params: action.payload,
        result,
      }),
    );

    onSuccess?.(result);
  });
}
